var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "50",
      "height": "50",
      "fill": "none"
    }
  }, _vm.$listeners), [_c('path', {
    attrs: {
      "stroke": "#005149",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M17.647 28.125c5.882-3.125 8.824-3.125 14.706 0m-20.588-7.812c11.764-6.25 14.706-6.25 26.47 0"
    }
  }), _c('circle', {
    attrs: {
      "cx": "25",
      "cy": "25",
      "r": "24",
      "stroke": "#005149",
      "stroke-width": "2"
    }
  }), _c('path', {
    attrs: {
      "fill": "#005149",
      "stroke": "#005149",
      "d": "M25.97 35.938c0 .615-.462 1.062-.97 1.062s-.97-.447-.97-1.063.462-1.062.97-1.062.97.447.97 1.063z"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }